import { render, staticRenderFns } from "./ShutterOtherDamages.vue?vue&type=template&id=37c0b070&scoped=true"
import script from "./ShutterOtherDamages.vue?vue&type=script&lang=ts"
export * from "./ShutterOtherDamages.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37c0b070",
  null
  
)

export default component.exports